interface FetchInertiaPartialOptions {
  component: string
  only: string[]
  /** `usePage().version` — without it the server treats the request as a stale bundle (409). */
  version: string | null | undefined
  signal?: AbortSignal
}

/**
 * Inertia partial reload done with a plain `fetch`, for data that must not touch the page's
 * own props (e.g. calendar month navigation). Resolves with the requested props, or `null`
 * after triggering a hard reload when the server reports a newer asset version.
 */
export const fetchInertiaPartial = async <Props>(
  url: URL,
  { component, only, version, signal }: FetchInertiaPartialOptions,
): Promise<Props | null> => {
  const response = await fetch(url.toString(), {
    signal,
    headers: {
      'X-Inertia': 'true',
      'X-Inertia-Partial-Component': component,
      'X-Inertia-Partial-Data': only.join(','),
      ...(version ? { 'X-Inertia-Version': version } : {}),
      Accept: 'application/json, text/plain, */*',
    },
  })

  if (response.status === 409) {
    window.location.reload()
    return null
  }
  if (!response.ok) throw new Error(`HTTP ${response.status}`)

  return ((await response.json()) as { props: Props }).props
}
